var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 16,
    cy: 16,
    r: 16,
    transform: "rotate(-180 16 16)",
    fill: "#313131"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.472 20.4673C13.1778 20.7589 13.1757 21.2338 13.4673 21.528C13.7589 21.8222 14.2338 21.8243 14.528 21.5327L16.3227 19.7539C16.9987 19.084 17.5511 18.5364 17.9429 18.0485C18.3504 17.5412 18.6453 17.0263 18.7241 16.4082C18.7586 16.1371 18.7586 15.8629 18.7241 15.5918C18.6453 14.9737 18.3504 14.4588 17.9429 13.9515C17.5511 13.4636 16.9987 12.916 16.3227 12.2461L14.528 10.4673C14.2338 10.1757 13.7589 10.1778 13.4673 10.472C13.1757 10.7662 13.1778 11.2411 13.472 11.5327L15.235 13.28C15.9505 13.9891 16.4413 14.4772 16.7734 14.8907C17.096 15.2924 17.2067 15.5504 17.2361 15.7815C17.2546 15.9266 17.2546 16.0734 17.2361 16.2185C17.2067 16.4496 17.096 16.7076 16.7734 17.1093C16.4413 17.5228 15.9505 18.0109 15.235 18.72L13.472 20.4673Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/BackButton.1cbdd555adf5446be66ea8cb983e2a5a.svg";
export { ForwardRef as ReactComponent };